import * as ActionTypes from '../actions/types.action';

export const completeProfile = data => ({
  type: ActionTypes.COMPLETE_PROFILE_REQUESTED,
  data,
});
export const completeProfileSuccess = () => ({
  type: ActionTypes.COMPLETE_PROFILE_SUCCESS,
});
export const completeProfileFailed = error => ({
  type: ActionTypes.COMPLETE_PROFILE_FAILED,
  error,
});
